import { render, staticRenderFns } from "./MiniCartItems.vue?vue&type=template&id=ae330508"
import script from "./MiniCartItems.vue?vue&type=script&lang=ts"
export * from "./MiniCartItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports